import React from 'react'
/* import {Link} from 'react-router-dom' */

export default function Navbar(props) {
  return (
    <nav className={`navbar navbar-expand-lg navbar-${props.mode} bg-${props.mode}`}>
    <div className="container-fluid">
    <a  className="navbar-brand" href="/#">{props.title}</a>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav me-auto mb-2 mb-lg-0">
        <li className="nav-item">
          <a  className={`nav-a active text-decoration-none text-${props.mode==='light'?'dark':'light'}`} aria-current="page" href="/#">Home</a>
        </li>
        <li className="nav-item">
          <a  className={`nav-a mx-3 text-decoration-none text-${props.mode==='light'?'dark':'light'}`} href="/about">{props.aboutText}</a>
        </li>
      </ul>
      <span> ☀️ </span>
      <div className={`form-check form-switch text-${props.mode==='light'?'dark':'light'}`} >
        <input onClick={props.toggleMode}  className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault"/>
        <label className="form-check-label" htmlFor="flexSwitchCheckDefault">🌒 Dark Mode</label>
      </div>
      
      
    </div>
  </div>
</nav>
  )
}
